import React from 'react';
import Masonry from 'react-masonry-css';
import SocialMediaMessage from '.';
import type { Props as MessageProps } from '.';
import './masonry.css';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';

interface Breakpoints {
  [key: number | string]: number;
}

interface Props {
  darkMode?: boolean;
  messages: MessageProps[];
  breakpoints: Breakpoints;
}

export default function MasonryLayout(props: Props) {
  const { messages, breakpoints, darkMode } = props;

  return (
    <Masonry
      breakpointCols={breakpoints}
      className='my-masonry-grid'
      columnClassName="my-masonry-grid_column"
    >
      {
        messages.map((message, i) => (
          <MessageMargins key={i}>
            <SocialMediaMessage darkMode={darkMode} {...message} />
          </MessageMargins>
        ))
      }
    </Masonry>
  );
}

const MessageMargins = styled(Box)(({ theme }) => ({
  marginBottom: '7px',
  [theme.mediaQueries.sm]: {
    marginBottom: '18px',
  }
}));
